import {
  captureException,
  setContext,
  setTag,
  setUser,
  withScope,
} from '@sentry/nextjs';

/**
 * `SentryLogger` 에 주입하는 SDK 어댑터 (`SentryLike` 가 요구하는 5개).
 *
 * 네임스페이스 객체를 넘기면 webpack 이 모든 export 를 살려 둬 번들 최적화가 무효가 된다.
 * 규칙: `.claude/rules/external-sdk-imports.md`
 */
export const sentryLoggerAdapter = {
  captureException,
  setContext,
  setTag,
  setUser,
  withScope,
};
